import s from './Logo.module.scss';

export default function Logo() {
  return (
    <span className={s.logo}>
      <span className={s.mark} aria-hidden="true" />
      MetaHub
    </span>
  );
}
